<template>
  <!--*组件名称
      * @desc 收发通信息组件
      * @author lwc
      * @date  2021年3月17日
      * @param {} []    - 参数说明
      * @param {} [] - 参数说明
      * @example 调用示例
          * @getEbPartyInfo="getEbPartyInfo"：子向父传值，父取值；
          * :cargoInfoForm="cargoInfoForm"：父向子传值，子组件中用props接收
          * //子向父传值：
          * this.$emit('getEbPartyInfo', objGroup)
          * //父取值
          * <send-receive-info
              @getEbPartyInfo = "getEbPartyInfo"
              :ebPartyInfoForm = "ebPartyInfoForm"/>
  -->
  <div class="eb-container">
    <el-form
        :disabled="billApprovalStatus || ebOrder.orderStatus === 'UPDSUB' || ebOrder.orderStatus === 'SUB' || ebOrder.orderStatus === 'CRM'"
        ref="ebPartyInfoFormRef" :rules="ebPartyInfoFormRules" :model="ebParty"
        class="form-panel" label-position="top">
             <el-row class="title-panel-external">
          <div class="title-panel" id="partys">
            <el-col>
             <span class="title-text">收发通信息</span>
            </el-col>
          </div>
         </el-row>
      <el-row class="content-panel transceiver">
        <el-col>
          <el-tabs type="card" v-model="ebPartyDialogForm.activeName" @tab-click="handleClick">
            <el-tab-pane class="tabs-pane" label="收发通" name="0">
              <el-row>
                <el-col>
                  <el-form
                      :disabled="billApprovalStatus ||ebOrder.orderStatus === 'UPDSUB' || ebOrder.orderStatus === 'SUB' || ebOrder.orderStatus === 'CRM'"
                      ref="ebPartySHInfoFormRef" :rules="ebPartySHInfoFormRules" :model="ebParty"
                      class="form-panel" label-position="top">
                    <el-form-item prop="ebPartySH.partyMainName">
                      <div>
                        <a style="color: rgba(253,56,70,0.93);font-size: 12px ">* </a>
                        <span class="link" slot="label" @click="ebPartyDialogVisible=true"
                              style="font-size: 12px">发货人: </span>
                        <span style="display: flex;float: right;">
                        <el-button
                          type="primary"
                          size="mini"
                          @click="splitPartyDescription(35)">35
                        </el-button>
                        <el-button
                            class="elbtn-save"
                          @click="saveShipperCneeNotifySH()"
                          ><svg-icon icon-class="save"></svg-icon>
                          保存模板
                        </el-button>
                        </span>
                      </div>
                      <el-associate
                          style="width: 100%"
                          :columns="associate_columns_part"
                          :query-method="associate_queryMethod_party_SH"
                          class="input_length"
                          clearable
                          :allow-create="true"
                          :query-length="0"
                          :default-first-option="true"
                          label-prop="shipperCneeNotifyNameEn"
                          value-prop="shipperCneeNotifyNameEn"
                          placeholder=""
                          v-model="ebParty.ebPartySH.partyMainName"
                          :title="ebParty.ebPartySH.partyMainName"
                          size="mini"
                          @change="onChangePartSH"
                          case="upper"
                      />
                    </el-form-item>
                    <el-form-item prop="ebPartySH.partyDescription">
                      <el-input
                          size="mini"
                          type="textarea"
                          @change="ebPartyInfoValue"
                          :rows="5"
                          case="upper"
                          ref="ebPartySH.partyDescription"
                          v-model="ebParty.ebPartySH.partyDescription"
                          :title="ebParty.ebPartySH.partyDescription"
                      >
                      </el-input>
                    </el-form-item>
                  </el-form>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form
                      :disabled="billApprovalStatus || ebOrder.orderStatus === 'UPDSUB' || ebOrder.orderStatus === 'SUB' || ebOrder.orderStatus === 'CRM'"
                      ref="ebPartyCNInfoFormRef" :rules="ebPartyCNInfoFormRules" :model="ebParty"
                      class="form-panel" label-position="top">
                    <el-form-item prop="ebPartyCN.partyMainName">
                      <div>
                        <a style="color: rgba(253,56,70,0.93);font-size: 12px ">* </a>
                        <span class="link" slot="label" @click="ebPartyDialogVisible=true"
                              style="font-size: 12px">收货人:</span>
                           <el-button
                            class="elbtn-save"
                          @click="saveShipperCneeNotifyCN()"
                          ><svg-icon icon-class="save"></svg-icon>
                          保存模板
                        </el-button>
                      </div>

                      <el-associate
                          style="width: 100%"
                          :columns="associate_columns_part"
                          :query-method="associate_queryMethod_party_CN"
                          class="input_length"
                          clearable
                          :allow-create="true"
                          :query-length="0"
                          :default-first-option="true"
                          label-prop="shipperCneeNotifyNameEn"
                          value-prop="shipperCneeNotifyNameEn"
                          placeholder=""
                          v-model="ebParty.ebPartyCN.partyMainName"
                          :title="ebParty.ebPartyCN.partyMainName"
                          size="mini"
                          @change="onChangePartCN"
                          case="upper"
                      />
                    </el-form-item>
                    <el-form-item prop="ebPartyCN.partyDescription">
                      <el-input
                          size="mini"
                          type="textarea"
                          @change="ebPartyInfoValue"
                          :rows="5"
                          case="upper"
                          ref="ebPartyCN.partyDescription"
                          v-model="ebParty.ebPartyCN.partyDescription"
                          :title="ebParty.ebPartyCN.partyDescription"
                      >
                      </el-input>
                    </el-form-item>
                  </el-form>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form
                      :disabled="billApprovalStatus || ebOrder.orderStatus === 'UPDSUB' || ebOrder.orderStatus === 'SUB' || ebOrder.orderStatus === 'CRM'"
                      ref="ebPartyNTInfoFormRef" :rules="ebPartyNTInfoFormRules" :model="ebParty"
                      class="form-panel" label-position="top">
                    <el-form-item prop="ebPartyNT.partyMainName">
                      <div>
                        <!--   使用a标签进行样式修改   -->
                        <a style="color: rgba(253,56,70,0.93);font-size: 12px ">* </a>
                        <span class="link" slot="label" @click="ebPartyDialogVisible=true"
                              style="font-size: 12px">通知人:</span>
                    <el-button
                          class="elbtn-save"
                          @click="saveShipperCneeNotifyNT()"
                          ><svg-icon icon-class="save"></svg-icon>
                          保存模板
                        </el-button>
                        <el-radio-group v-model="radio" @change="copyCnee" class="notify">
                          <el-radio label="1">COPY CNEE</el-radio>
                          <el-radio label="2">SAME AS CONSIGNEE</el-radio>
                        </el-radio-group>
                      </div>
                      <el-associate
                          style="width: 100%"
                          :columns="associate_columns_part"
                          :query-method="associate_queryMethod_party_NT"
                          class="input_length"
                          clearable
                          :query-length="0"
                          :allow-create="true"
                          :default-first-option="true"
                          label-prop="shipperCneeNotifyNameEn"
                          value-prop="shipperCneeNotifyNameEn"
                          placeholder=""
                          v-model="ebParty.ebPartyNT.partyMainName"
                          :title="ebParty.ebPartyNT.partyMainName"
                          size="mini"
                          @change="onChangePartNT"
                          case="upper"
                      />
                    </el-form-item>
                    <el-form-item prop="ebPartyNT.partyDescription">
                      <el-input
                          size="mini"
                          type="textarea"
                          @change="ebPartyInfoValue"
                          case="upper"
                          :rows="5"
                          ref="ebPartyNT.partyDescription"
                          v-model="ebParty.ebPartyNT.partyDescription"
                          :title="ebParty.ebPartyNT.partyDescription"
                      >
                      </el-input>
                    </el-form-item>
                  </el-form>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form
                    :disabled="billApprovalStatus || ebOrder.orderStatus === 'UPDSUB' || ebOrder.orderStatus === 'SUB' || ebOrder.orderStatus === 'CRM'"
                    ref="ebPartyNT2InfoFormRef"  :model="ebParty"
                    class="form-panel" label-position="top">
                    <el-form-item prop="ebPartyNT.partyMainName">
                      <div>
                        <!--   使用a标签进行样式修改   -->
<!--                        <a style="color: rgba(253,56,70,0.93);font-size: 12px ">* </a>-->
                        <span class="link" slot="label" @click="ebPartyDialogVisible=true"
                              style="font-size: 12px">第二通知人:</span>
                          <el-button
                          class="elbtn-save"
                           @click="saveShipperCneeNotifyNT2()"
                          ><svg-icon icon-class="save"></svg-icon>
                          保存模板
                        </el-button>
                      </div>
                      <el-associate
                        style="width: 100%"
                        :columns="associate_columns_part"
                        :query-method="associate_queryMethod_party_NT2"
                        class="input_length"
                        clearable
                        :query-length="0"
                        :allow-create="true"
                        :default-first-option="true"
                        label-prop="shipperCneeNotifyNameEn"
                        value-prop="shipperCneeNotifyNameEn"
                        placeholder=""
                        v-model="ebParty.ebPartyNT2.partyMainName"
                        :title="ebParty.ebPartyNT2.partyMainName"
                        size="mini"
                        @change="onChangePartNT2"
                        case="upper"
                      />
                    </el-form-item>
                    <el-form-item prop="ebPartyNT2.partyDescription">
                      <el-input
                        size="mini"
                        type="textarea"
                        @change="ebPartyInfoValue"
                        case="upper"
                        :rows="5"
                        ref="ebPartyNT2.partyDescription"
                        v-model="ebParty.ebPartyNT2.partyDescription"
                        :title="ebParty.ebPartyNT2.partyDescription"
                      >
                      </el-input>
                    </el-form-item>
                  </el-form>
                </el-col>
              </el-row>
            </el-tab-pane>
            <el-tab-pane class="tabs-pane" label="真实收发通" v-if="!loadingEditKey" name="1">
              <el-row>
                <el-col>
                  <el-form
                    :disabled="billApprovalStatus ||ebOrder.orderStatus === 'UPDSUB' || ebOrder.orderStatus === 'SUB' || ebOrder.orderStatus === 'CRM'"
                    ref="ebPartyRSHInfoFormRef"
                    :rules="ebPartyRSHInfoFormRules"
                    :model="ebParty"
                    class="form-panel"
                    label-position="top"
                  >
                    <el-form-item prop="ebPartyRSH.partyMainName">
                      <div>
                        <span class="link" slot="label" @click="ebPartyDialogVisible=true"
                              style="font-size: 12px">真实发货人: </span>
                         <el-button
                          class="elbtn-save"
                          @click="saveShipperCneeNotifyRSH()"
                          ><svg-icon icon-class="save"></svg-icon>
                          保存模板
                        </el-button>
                      </div>
                      <el-associate
                        style="width: 100%"
                        :columns="associate_columns_part"
                        :query-method="associate_queryMethod_party_SH"
                        class="input_length"
                        clearable
                        :allow-create="true"
                        :query-length="0"
                        :default-first-option="true"
                        label-prop="shipperCneeNotifyNameEn"
                        value-prop="shipperCneeNotifyNameEn"
                        placeholder=""
                        v-model="ebParty.ebPartyRSH.partyMainName"
                        :title="ebParty.ebPartyRSH.partyMainName"
                        size="mini"
                        @change="onChangePartRSH"
                        case="upper"
                      />
                    </el-form-item>
                    <el-form-item prop="ebPartyRSH.partyDescription">
                      <el-input
                        size="mini"
                        type="textarea"
                        @input="inputForceUpdate"
                        :rows="6"
                        case="upper"
                        ref="ebPartyRSH.partyDescription"
                        v-model="ebParty.ebPartyRSH.partyDescription"
                        :title="ebParty.ebPartyRSH.partyDescription"
                      >
                      </el-input>
                    </el-form-item>
                  </el-form>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form
                    :disabled="billApprovalStatus || ebOrder.orderStatus === 'UPDSUB' || ebOrder.orderStatus === 'SUB' || ebOrder.orderStatus === 'CRM'"
                    ref="ebPartyRCNInfoFormRef" :rules="ebPartyRCNInfoFormRules" :model="ebParty"
                    class="form-panel" label-position="top">
                    <el-form-item prop="ebPartyRCN.partyMainName">
                      <div>
                        <span class="link" slot="label" @click="ebPartyDialogVisible=true"
                              style="font-size: 12px">真实收货人:</span>
                          <el-button
                          class="elbtn-save"
                          @click="saveShipperCneeNotifyRCN()"
                          ><svg-icon icon-class="save"></svg-icon>
                          保存模板
                        </el-button>
                      </div>

                      <el-associate
                        style="width: 100%"
                        :columns="associate_columns_part"
                        :query-method="associate_queryMethod_party_CN"
                        class="input_length"
                        clearable
                        :allow-create="true"
                        :query-length="0"
                        :default-first-option="true"
                        label-prop="shipperCneeNotifyNameEn"
                        value-prop="shipperCneeNotifyNameEn"
                        placeholder=""
                        v-model="ebParty.ebPartyRCN.partyMainName"
                        :title="ebParty.ebPartyRCN.partyMainName"
                        size="mini"
                        @change="onChangePartRCN"
                        case="upper"
                      />
                    </el-form-item>
                    <el-form-item prop="ebPartyRCN.partyDescription">
                      <el-input
                        size="mini"
                        type="textarea"
                        @input="inputForceUpdate"
                        :rows="6"
                        case="upper"
                        ref="ebPartyRCN.partyDescription"
                        v-model="ebParty.ebPartyRCN.partyDescription"
                        :title="ebParty.ebPartyRCN.partyDescription"
                      >
                      </el-input>
                    </el-form-item>
                  </el-form>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form
                    :disabled="billApprovalStatus || ebOrder.orderStatus === 'UPDSUB' || ebOrder.orderStatus === 'SUB' || ebOrder.orderStatus === 'CRM'"
                    ref="ebPartyRNTInfoFormRef" :rules="ebPartyRNTInfoFormRules" :model="ebParty"
                    class="form-panel" label-position="top">
                    <el-form-item prop="ebPartyRNT.partyMainName">
                      <div>
                        <!--   使用a标签进行样式修改   -->
                        <span class="link" slot="label" @click="ebPartyDialogVisible=true"
                              style="font-size: 12px">真实通知人:</span>
                          <el-button
                          class="elbtn-save"
                          @click="saveShipperCneeNotifyRNT()"
                          ><svg-icon icon-class="save"></svg-icon>
                          保存模板
                        </el-button>
                        <el-radio-group v-model="radio1" @change="copyRCnee" class="notify">
                          <el-radio label="1">COPY CNEE</el-radio>
                          <el-radio label="2">SAME AS CONSIGNEE</el-radio>
                        </el-radio-group>
                      </div>
                      <el-associate
                        style="width: 100%"
                        :columns="associate_columns_part"
                        :query-method="associate_queryMethod_party_NT"
                        class="input_length"
                        clearable
                        :query-length="0"
                        :allow-create="true"
                        :default-first-option="true"
                        label-prop="shipperCneeNotifyNameEn"
                        value-prop="shipperCneeNotifyNameEn"
                        placeholder=""
                        v-model="ebParty.ebPartyRNT.partyMainName"
                        :title="ebParty.ebPartyRNT.partyMainName"
                        size="mini"
                        @change="onChangePartRNT"
                        case="upper"
                      />
                    </el-form-item>
                    <el-form-item prop="ebPartyRNT.partyDescription">
                      <el-input
                        size="mini"
                        type="textarea"
                        @input="inputForceUpdate"
                        case="upper"
                        :rows="6"
                        ref="ebPartyRNT.partyDescription"
                        v-model="ebParty.ebPartyRNT.partyDescription"
                        :title="ebParty.ebPartyRNT.partyDescription"
                      >
                      </el-input>
                    </el-form-item>
                  </el-form>
                </el-col>
              </el-row>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
    </el-form>
    <!-- 收发通弹框 -->
    <el-dialog
        :visible.sync="ebPartyDialogVisible"
        width="90%"
        class="booking-panel">
           <el-row class="title-panel-external">
          <div class="title-panel">
            <el-col>
            <span class="title-text">收发通</span>
          </el-col>
          </div>
        </el-row>
      <el-form
          :disabled="billApprovalStatus || ebOrder.orderStatus === 'UPDSUB' || ebOrder.orderStatus === 'SUB' || ebOrder.orderStatus === 'CRM'"
          ref="ebPartyDialogFormRef" :rules="ebPartyDialogFormRules" :model="ebPartyDialogForm"
          class="form-panel" label-position="top">
        <el-tabs type="card" v-model="ebPartyDialogForm.activeName">
          <el-tab-pane label="收发通" name="0">
            <el-row type="flex" justify="start" align="top" :gutter="10" style="padding: 0px 5px;">
              <el-col :span="6">
                <el-row class="cargo-type">
                   <el-row class="title-panel cargo-type-title-panel">
                    <el-col>
                      <span class="title-text cargo-title-text">发货人</span>
                    </el-col>
                  </el-row>
                  <el-form
                      :disabled="billApprovalStatus || ebOrder.orderStatus === 'UPDSUB' || ebOrder.orderStatus === 'SUB' || ebOrder.orderStatus === 'CRM'"
                      ref="ebPartySHDialogFormRef" :rules="ebPartySHDialogFormRules" :model="ebParty.ebPartySH"
                      class="form-panel" label-position="top">
                    <el-col>
                      <el-form-item label="名称:" prop="partyMainName">
                        <el-input case="upper" size="mini" v-model="ebParty.ebPartySH.partyMainName" :title="ebParty.ebPartySH.partyMainName"
                                  @input="inputForceUpdate"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-form-item label="地址:" prop="partyAddress">
                        <el-input
                            size="mini"
                            type="textarea"
                            :rows="3"
                            case="upper"
                            v-model="ebParty.ebPartySH.partyAddress"
                            :title="ebParty.ebPartySH.partyAddress"
                            @input="inputForceUpdate">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="国家/地区" prop="countryName">
                            <el-associate style="width: 100%;"
                                          :columns="associate_columns_country"
                                          :query-method="associate_queryMethod_country"
                                          class="input_length"
                                          clearable
                                          :query-length="0"
                                          :default-first-option="true"
                                          label-prop="countryNameCn"
                                          value-prop="countryNameCn"
                                          placeholder=""
                                          case="upper"
                                          @change="onChangeCountryEbPartySH"
                                          v-model="ebParty.ebPartySH.countryName"
                                          :title="ebParty.ebPartySH.countryName"
                                          size="mini"
                            />
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item prop="areaName">
                            <label slot="label" class="label_no"></label>
                            <el-input
                                size="mini"
                                case="upper"
                                v-model="ebParty.ebPartySH.areaName"
                                :title="ebParty.ebPartySH.areaName"
                                @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="邮编/邮箱" prop="postCode">
                            <el-input
                                size="mini"
                                case="upper"
                                v-model="ebParty.ebPartySH.postCode" :title="ebParty.ebPartySH.postCode" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item prop="email">
                            <label slot="label" class="label_no"></label>
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartySH.email"
                                v-model="ebParty.ebPartySH.email" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="联系人/移动电话" prop="contactPerson">
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartySH.contactPerson"
                                v-model="ebParty.ebPartySH.contactPerson" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item prop="mobilePhone">
                            <label slot="label" class="label_no"></label>
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartySH.mobilePhone"
                                v-model="ebParty.ebPartySH.mobilePhone" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-form-item label="海关代码:" prop="taxNo">
                        <el-input
                            size="mini"
                            case="upper"
                            :title="ebParty.ebPartySH.taxNo"
                            v-model="ebParty.ebPartySH.taxNo" @input="inputForceUpdate">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="AEO代码/船公司代码" prop="aeoNo">
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartySH.aeoNo"
                                v-model="ebParty.ebPartySH.aeoNo" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item prop="carrierCode">
                            <label slot="label" class="label_no"></label>
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartySH.carrierCode"
                                v-model="ebParty.ebPartySH.carrierCode" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-form>
                </el-row>
              </el-col>
              <el-col :span="6">
                <el-row class="cargo-type">
                    <el-row class="title-panel cargo-type-title-panel">
                      <el-col>
                        <span class="title-text cargo-title-text">收货人</span>
                      </el-col>
                    </el-row>
                  <el-form
                      :disabled="billApprovalStatus || ebOrder.orderStatus === 'UPDSUB' || ebOrder.orderStatus === 'SUB' || ebOrder.orderStatus === 'CRM'"
                      ref="ebPartyCNDialogFormRef" :rules="ebPartyCNDialogFormRules" :model="ebParty.ebPartyCN"
                      class="form-panel" label-position="top">
                    <el-col>
                      <el-form-item label="名称:" prop="partyMainName">
                        <el-input size="mini" case="upper"
                                  v-model="ebParty.ebPartyCN.partyMainName"
                                  :title="ebParty.ebPartyCN.partyMainName"
                                  @input="inputForceUpdate"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-form-item label="地址:" prop="partyAddress">
                        <el-input
                            size="mini"
                            case="upper"
                            type="textarea"
                            :rows="3"
                            :title="ebParty.ebPartyCN.partyAddress"
                            v-model="ebParty.ebPartyCN.partyAddress"
                            @input="inputForceUpdate">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="国家/地区" prop="countryName">
                            <el-associate style="width: 100%;"
                                          :columns="associate_columns_country"
                                          :query-method="associate_queryMethod_country"
                                          class="input_length"
                                          clearable
                                          case="upper"
                                          :query-length="0"
                                          :default-first-option="true"
                                          label-prop="countryNameCn"
                                          value-prop="countryNameCn"
                                          placeholder=""
                                          @change="onChangeCountryEbPartyCN"
                                          v-model="ebParty.ebPartyCN.countryName"
                                          :title="ebParty.ebPartyCN.countryName"
                                          size="mini"
                            />
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item prop="areaName">
                            <label slot="label" class="label_no"></label>
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartyCN.areaName"
                                v-model="ebParty.ebPartyCN.areaName" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="邮编/邮箱" prop="postCode">
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartyCN.postCode"
                                v-model="ebParty.ebPartyCN.postCode" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item prop="email">
                            <label slot="label" class="label_no"></label>
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartyCN.email"
                                v-model="ebParty.ebPartyCN.email" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="联系人/移动电话" prop="contactPerson">
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartyCN.contactPerson"
                                v-model="ebParty.ebPartyCN.contactPerson" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item prop="mobilePhone">
                            <label slot="label" class="label_no"></label>
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartyCN.mobilePhone"
                                v-model="ebParty.ebPartyCN.mobilePhone" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-form-item label="海关代码:" prop="taxNo">
                        <el-input
                            size="mini"
                            case="upper"
                            :title="ebParty.ebPartyCN.taxNo"
                            v-model="ebParty.ebPartyCN.taxNo" @input="inputForceUpdate">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="AEO代码/船公司代码" prop="aeoNo">
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartyCN.aeoNo"
                                v-model="ebParty.ebPartyCN.aeoNo" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item prop="carrierCode">
                            <label slot="label" class="label_no"></label>
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartyCN.carrierCode"
                                v-model="ebParty.ebPartyCN.carrierCode" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-form>
                </el-row>
              </el-col>
              <el-col :span="6">
                <el-row class="cargo-type">
               <el-row class="title-panel cargo-type-title-panel">
                <el-col>
                  <span class="title-text cargo-title-text">通知人</span>
                </el-col>
              </el-row>
                  <el-form
                      :disabled="billApprovalStatus || ebOrder.orderStatus === 'UPDSUB' || ebOrder.orderStatus === 'SUB' || ebOrder.orderStatus === 'CRM'"
                      ref="ebPartyNTDialogFormRef" :rules="ebPartyNTDialogFormRules" :model="ebParty.ebPartyNT"
                      class="form-panel" label-position="top">
                    <el-col>
                      <el-form-item label="名称:" prop="partyMainName">
                        <el-input size="mini" case="upper" v-model="ebParty.ebPartyNT.partyMainName"
                                  :title="ebParty.ebPartyNT.partyMainName"
                                  @input="inputForceUpdate"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-form-item label="地址:" prop="partyAddress">
                        <el-input
                            size="mini"
                            type="textarea"
                            :rows="3"
                            case="upper"
                            :title="ebParty.ebPartyNT.partyAddress"
                            v-model="ebParty.ebPartyNT.partyAddress" @input="inputForceUpdate">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="国家/地区" prop="countryName">
                            <el-associate style="width: 100%;"
                                          :columns="associate_columns_country"
                                          :query-method="associate_queryMethod_country"
                                          class="input_length"
                                          clearable
                                          case="upper"
                                          :query-length="0"
                                          :default-first-option="true"
                                          label-prop="countryNameCn"
                                          value-prop="countryNameCn"
                                          placeholder=""
                                          @change="onChangeCountryEbPartyNT"
                                          v-model="ebParty.ebPartyNT.countryName"
                                          :title="ebParty.ebPartyNT.countryName"
                                          size="mini"
                            />
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item prop="areaName">
                            <label slot="label" class="label_no"></label>
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartyNT.areaName"
                                v-model="ebParty.ebPartyNT.areaName" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="邮编/邮箱" prop="postCode">
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartyNT.postCode"
                                v-model="ebParty.ebPartyNT.postCode" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item prop="email">
                            <label slot="label" class="label_no"></label>
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartyNT.email"
                                v-model="ebParty.ebPartyNT.email" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="联系人/移动电话" prop="contactPerson">
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartyNT.contactPerson"
                                v-model="ebParty.ebPartyNT.contactPerson" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item prop="mobilePhone">
                            <label slot="label" class="label_no"></label>
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartyNT.mobilePhone"
                                v-model="ebParty.ebPartyNT.mobilePhone" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-form-item label="海关代码:" prop="taxNo">
                        <el-input
                            size="mini"
                            case="upper"
                            :title="ebParty.ebPartyNT.taxNo"
                            v-model="ebParty.ebPartyNT.taxNo" @input="inputForceUpdate">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="AEO代码/船公司代码" prop="aeoNo">
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartyNT.aeoNo"
                                v-model="ebParty.ebPartyNT.aeoNo" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item prop="carrierCode">
                            <label slot="label" class="label_no"></label>
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartyNT.carrierCode"
                                v-model="ebParty.ebPartyNT.carrierCode" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-form>
                </el-row>
              </el-col>
              <el-col :span="6" class="notify-unit">
               <el-row class="cargo-type second-notifier">
                <el-tabs type="card" class="el-tab_tran" v-model="ebPartyDialogForm.activeChildName" @tab-click="handleClick">
                  <el-tab-pane class="el-tab_tran" label="第二通知人" name="0">
                    <el-form
                        :disabled="billApprovalStatus || ebOrder.orderStatus === 'UPDSUB' || ebOrder.orderStatus === 'SUB' || ebOrder.orderStatus === 'CRM'"
                        ref="ebPartyNT2DialogFormRef" :rules="ebPartyNT2DialogFormRules"
                        :model="ebParty.ebPartyNT2"
                        class="form-panel" label-position="top">
                      <el-row>
                        <el-col>
                          <el-form-item label="名称:" prop="partyMainName">
                            <el-input size="mini" case="upper"
                                      :title="ebParty.ebPartyNT2.partyMainName"
                                      v-model="ebParty.ebPartyNT2.partyMainName"
                                      @input="inputForceUpdate"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col>
                          <el-form-item label="地址:" prop="partyAddress">
                            <el-input
                                size="mini"
                                type="textarea"
                                :rows="3"
                                case="upper"
                                :title="ebParty.ebPartyNT2.partyAddress"
                                v-model="ebParty.ebPartyNT2.partyAddress" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col>
                          <el-row>
                            <el-col :span="12">
                              <el-form-item label="国家/地区" prop="countryName">
                                <el-associate style="width: 100%;"
                                              :columns="associate_columns_country"
                                              :query-method="associate_queryMethod_country"
                                              class="input_length"
                                              clearable
                                              case="upper"
                                              :query-length="0"
                                              :default-first-option="true"
                                              label-prop="countryNameCn"
                                              value-prop="countryNameCn"
                                              placeholder=""
                                              @change="onChangeCountryEbPartyNT2"
                                              v-model="ebParty.ebPartyNT2.countryName"
                                              :title="ebParty.ebPartyNT2.countryName"
                                              size="mini"
                                />
                              </el-form-item>
                            </el-col>
                            <el-col :span="12">
                              <el-form-item prop="areaName">
                                <label slot="label" class="label_no"></label>
                                <el-input
                                    size="mini"
                                    case="upper"
                                    :title="ebParty.ebPartyNT2.areaName"
                                    v-model="ebParty.ebPartyNT2.areaName" @input="inputForceUpdate">
                                </el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>
                        </el-col>
                        <el-col>
                          <el-row>
                            <el-col :span="12">
                              <el-form-item label="邮编/邮箱" prop="postCode">
                                <el-input
                                    size="mini"
                                    case="upper"
                                    :title="ebParty.ebPartyNT2.postCode"
                                    v-model="ebParty.ebPartyNT2.postCode" @input="inputForceUpdate">
                                </el-input>
                              </el-form-item>
                            </el-col>
                            <el-col :span="12">
                              <el-form-item prop="email">
                                <label slot="label" class="label_no"></label>
                                <el-input
                                    size="mini"
                                    case="upper"
                                    :title="ebParty.ebPartyNT2.email"
                                    v-model="ebParty.ebPartyNT2.email" @input="inputForceUpdate">
                                </el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>
                        </el-col>
                        <el-col>
                          <el-row>
                            <el-col :span="12">
                              <el-form-item label="联系人/移动电话" prop="contactPerson">
                                <el-input
                                    size="mini"
                                    case="upper"
                                    :title="ebParty.ebPartyNT2.contactPerson"
                                    v-model="ebParty.ebPartyNT2.contactPerson" @input="inputForceUpdate">
                                </el-input>
                              </el-form-item>
                            </el-col>
                            <el-col :span="12">
                              <el-form-item prop="mobilePhone">
                                <label slot="label" class="label_no"></label>
                                <el-input
                                    size="mini"
                                    case="upper"
                                    :title="ebParty.ebPartyNT2.mobilePhone"
                                    v-model="ebParty.ebPartyNT2.mobilePhone" @input="inputForceUpdate">
                                </el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>
                        </el-col>
                        <el-col>
                          <el-form-item label="海关代码:" prop="taxNo">
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartyNT2.taxNo"
                                v-model="ebParty.ebPartyNT2.taxNo" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col>
                          <el-row>
                            <el-col :span="12">
                              <el-form-item label="AEO代码/船公司代码" prop="aeoNo">
                                <el-input
                                    size="mini"
                                    case="upper"
                                    :title="ebParty.ebPartyNT2.aeoNo"
                                    v-model="ebParty.ebPartyNT2.aeoNo" @input="inputForceUpdate">
                                </el-input>
                              </el-form-item>
                            </el-col>
                            <el-col :span="12">
                              <el-form-item prop="carrierCode">
                                <label slot="label" class="label_no"></label>
                                <el-input
                                    size="mini"
                                    case="upper"
                                    :title="ebParty.ebPartyNT2.carrierCode"
                                    v-model="ebParty.ebPartyNT2.carrierCode" @input="inputForceUpdate">
                                </el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>
                        </el-col>
                      </el-row>
                    </el-form>
                  </el-tab-pane>
                  <el-tab-pane label="DG装箱单位" name="1">
                    <el-form
                      :disabled="billApprovalStatus || ebOrder.orderStatus === 'UPDSUB' || ebOrder.orderStatus === 'SUB' || ebOrder.orderStatus === 'CRM'"
                      ref="ebPartyDGDialogFormRef" :rules="ebPartyDGDialogFormRules"
                      :model="ebParty.ebPartyDG"
                      class="form-panel" label-position="top">
                      <el-row>
                        <el-col>
                          <el-form-item label="名称:">
                            <el-input size="mini" case="upper"
                                      :title="ebParty.ebPartyDG.partyMainName"
                                      v-model="ebParty.ebPartyDG.partyMainName"
                                      @input="inputForceUpdate"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col>
                          <el-form-item label="地址:">
                            <el-input
                              size="mini"
                              type="textarea"
                              :rows="3"
                              case="upper"
                              :title="ebParty.ebPartyDG.partyAddress"
                              v-model="ebParty.ebPartyDG.partyAddress" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col>
                          <el-row>
                            <el-col :span="12">
                              <el-form-item label="国家/地区">
                                <el-associate style="width: 100%;"
                                              :columns="associate_columns_country"
                                              :query-method="associate_queryMethod_country"
                                              class="input_length"
                                              clearable
                                              :query-length="0"
                                              case="upper"
                                              :default-first-option="true"
                                              label-prop="countryNameCn"
                                              value-prop="countryNameCn"
                                              placeholder=""
                                              @change="onChangeCountryEbPartyDG"
                                              v-model="ebParty.ebPartyDG.countryName"
                                              :title="ebParty.ebPartyDG.countryName"
                                              size="mini"
                                />
                              </el-form-item>
                            </el-col>
                            <el-col :span="12">
                              <el-form-item>
                                <label slot="label" class="label_no"></label>
                                <el-input
                                  size="mini"
                                  case="upper"
                                  :title="ebParty.ebPartyDG.areaName"
                                  v-model="ebParty.ebPartyDG.areaName" @input="inputForceUpdate">
                                </el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>
                        </el-col>
                        <el-col>
                          <el-row>
                            <el-col :span="12">
                              <el-form-item label="邮编/邮箱">
                                <el-input
                                  size="mini"
                                  case="upper"
                                  :title="ebParty.ebPartyDG.postCode"
                                  v-model="ebParty.ebPartyDG.postCode" @input="inputForceUpdate">
                                </el-input>
                              </el-form-item>
                            </el-col>
                            <el-col :span="12">
                              <el-form-item>
                                <label slot="label" class="label_no" @input="inputForceUpdate"></label>
                                <el-input
                                  size="mini"
                                  case="upper"
                                  :title="ebParty.ebPartyDG.email"
                                  v-model="ebParty.ebPartyDG.email">
                                </el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>
                        </el-col>
                        <el-col>
                          <el-row>
                            <el-col :span="12">
                              <el-form-item label="联系人/移动电话">
                                <el-input
                                  size="mini"
                                  case="upper"
                                  :title="ebParty.ebPartyDG.contactPerson"
                                  v-model="ebParty.ebPartyDG.contactPerson" @input="inputForceUpdate">
                                </el-input>
                              </el-form-item>
                            </el-col>
                            <el-col :span="12">
                              <el-form-item>
                                <label slot="label" class="label_no"></label>
                                <el-input
                                  size="mini"
                                  case="upper"
                                  :title="ebParty.ebPartyDG.mobilePhone"
                                  v-model="ebParty.ebPartyDG.mobilePhone" @input="inputForceUpdate">
                                </el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>
                        </el-col>
                        <el-col>
                          <el-form-item label="海关代码:">
                            <el-input
                              size="mini"
                              case="upper"
                              :title="ebParty.ebPartyDG.taxNo"
                              v-model="ebParty.ebPartyDG.taxNo" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col>
                          <el-row>
                            <el-col :span="12">
                              <el-form-item label="AEO代码/船公司代码">
                                <el-input
                                  size="mini"
                                  case="upper"
                                  :title="ebParty.ebPartyDG.aeoNo"
                                  v-model="ebParty.ebPartyDG.aeoNo" @input="inputForceUpdate">
                                </el-input>
                              </el-form-item>
                            </el-col>
                            <el-col :span="12">
                              <el-form-item>
                                <label slot="label" class="label_no"></label>
                                <el-input
                                  size="mini"
                                  case="upper"
                                  :title="ebParty.ebPartyDG.carrierCode"
                                  v-model="ebParty.ebPartyDG.carrierCode" @input="inputForceUpdate">
                                </el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>
                        </el-col>
                      </el-row>
                    </el-form>
                  </el-tab-pane>
                </el-tabs>
              </el-row>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="真实收发通" name="1">
            <el-row type="flex" justify="start" align="top" :gutter="10" style="padding:0px 5px;">
              <el-col :span="6">
                <el-row class="cargo-type">
                  <el-row class="title-panel cargo-type-title-panel">
                    <el-col>
                      <span class="title-text cargo-title-text">真实发货人</span>
                    </el-col>
                  </el-row>
                  <el-form
                      :disabled="billApprovalStatus || ebOrder.orderStatus === 'UPDSUB' || ebOrder.orderStatus === 'SUB' || ebOrder.orderStatus === 'CRM'"
                      ref="ebPartyRSHDialogFormRef" :rules="ebPartyRSHDialogFormRules" :model="ebParty.ebPartyRSH"
                      class="form-panel" label-position="top">
                    <el-col>
                      <el-form-item label="名称:">
                        <el-input size="mini" case="upper"
                                  :title="ebParty.ebPartyRSH.partyMainName"
                                  v-model="ebParty.ebPartyRSH.partyMainName"
                                  @input="inputForceUpdate"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-form-item label="地址:">
                        <el-input
                            size="mini"
                            case="upper"
                            type="textarea"
                            :rows="3"
                            :title="ebParty.ebPartyRSH.partyAddress"
                            v-model="ebParty.ebPartyRSH.partyAddress" @input="inputForceUpdate">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="国家/地区">
                            <el-associate style="width: 100%;"
                                          :columns="associate_columns_country"
                                          :query-method="associate_queryMethod_country"
                                          class="input_length"
                                          clearable
                                          case="upper"
                                          :query-length="0"
                                          :default-first-option="true"
                                          label-prop="countryNameCn"
                                          value-prop="countryNameCn"
                                          placeholder=""
                                          @change="onChangeCountryEbPartyRSH"
                                          v-model="ebParty.ebPartyRSH.countryName"
                                          :title="ebParty.ebPartyRSH.countryName"
                                          size="mini"
                            />
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item>
                            <label slot="label" class="label_no"></label>
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartyRSH.areaName"
                                v-model="ebParty.ebPartyRSH.areaName" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="邮编/邮箱">
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartyRSH.postCode"
                                v-model="ebParty.ebPartyRSH.postCode" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item>
                            <label slot="label" class="label_no"></label>
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartyRSH.email"
                                v-model="ebParty.ebPartyRSH.email" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="联系人/移动电话">
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartyRSH.contactPerson"
                                v-model="ebParty.ebPartyRSH.contactPerson" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item>
                            <label slot="label" class="label_no"></label>
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartyRSH.mobilePhone"
                                v-model="ebParty.ebPartyRSH.mobilePhone" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-form-item label="海关代码:">
                        <el-input
                            size="mini"
                            case="upper"
                            :title="ebParty.ebPartyRSH.taxNo"
                            v-model="ebParty.ebPartyRSH.taxNo" @input="inputForceUpdate">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="AEO代码/船公司代码">
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartyRSH.aeoNo"
                                v-model="ebParty.ebPartyRSH.aeoNo" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item>
                            <label slot="label" class="label_no"></label>
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartyRSH.carrierCode"
                                v-model="ebParty.ebPartyRSH.carrierCode" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-form>
                </el-row>
              </el-col>
              <el-col :span="6">
                 <el-row class="cargo-type">
               <el-row class="title-panel cargo-type-title-panel">
                <el-col>
                  <span class="title-text cargo-title-text">真实收货人</span>
                </el-col>
              </el-row>
                  <el-form
                      :disabled="billApprovalStatus || ebOrder.orderStatus === 'UPDSUB' || ebOrder.orderStatus === 'SUB' || ebOrder.orderStatus === 'CRM'"
                      ref="ebPartyRCNDialogFormRef" :rules="ebPartyRCNDialogFormRules" :model="ebParty.ebPartyRCN"
                      class="form-panel" label-position="top">
                    <el-col>
                      <el-form-item label="名称:">
                        <el-input size="mini" case="upper"
                                  :title="ebParty.ebPartyRCN.partyMainName"
                                  v-model="ebParty.ebPartyRCN.partyMainName"
                                  @input="inputForceUpdate"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-form-item label="地址:">
                        <el-input
                            size="mini"
                            type="textarea"
                            :rows="3"
                            case="upper"
                            :title="ebParty.ebPartyRCN.partyAddress"
                            v-model="ebParty.ebPartyRCN.partyAddress" @input="inputForceUpdate">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="国家/地区">
                            <el-associate style="width: 100%;"
                                          :columns="associate_columns_country"
                                          :query-method="associate_queryMethod_country"
                                          class="input_length"
                                          clearable
                                          case="upper"
                                          :query-length="0"
                                          :default-first-option="true"
                                          label-prop="countryNameCn"
                                          value-prop="countryNameCn"
                                          placeholder=""
                                          @change="onChangeCountryEbPartyRCN"
                                          v-model="ebParty.ebPartyRCN.countryName"
                                          :title="ebParty.ebPartyRCN.countryName"
                                          size="mini"
                            />
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item>
                            <label slot="label" class="label_no"></label>
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartyRCN.areaName"
                                v-model="ebParty.ebPartyRCN.areaName" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="邮编/邮箱">
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartyRCN.postCode"
                                v-model="ebParty.ebPartyRCN.postCode" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item>
                            <label slot="label" class="label_no"></label>
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartyRCN.email"
                                v-model="ebParty.ebPartyRCN.email" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="联系人/移动电话">
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartyRCN.contactPerson"
                                v-model="ebParty.ebPartyRCN.contactPerson" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item>
                            <label slot="label" class="label_no"></label>
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartyRCN.mobilePhone"
                                v-model="ebParty.ebPartyRCN.mobilePhone" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-form-item label="海关代码:">
                        <el-input
                            size="mini"
                            case="upper"
                            :title="ebParty.ebPartyRCN.taxNo"
                            v-model="ebParty.ebPartyRCN.taxNo" @input="inputForceUpdate">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="AEO代码/船公司代码">
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartyRCN.aeoNo"
                                v-model="ebParty.ebPartyRCN.aeoNo" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item>
                            <label slot="label" class="label_no"></label>
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartyRCN.carrierCode"
                                v-model="ebParty.ebPartyRCN.carrierCode" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-form>
                </el-row>
              </el-col>
              <el-col :span="6">
            <el-row class="cargo-type">
                <el-row class="title-panel cargo-type-title-panel">
                  <el-col>
                    <span class="title-text cargo-title-text">真实通知人</span>
                  </el-col>
                </el-row>
                  <el-form
                      :disabled="billApprovalStatus || ebOrder.orderStatus === 'UPDSUB' || ebOrder.orderStatus === 'SUB' || ebOrder.orderStatus === 'CRM'"
                      ref="ebPartyRNTDialogFormRef" :rules="ebPartyRNTDialogFormRules" :model="ebParty.ebPartyRNT"
                      class="form-panel" label-position="top">
                    <el-col>
                      <el-form-item label="名称:">
                        <el-input size="mini" case="upper"
                                  :title="ebParty.ebPartyRNT.partyMainName"
                                  v-model="ebParty.ebPartyRNT.partyMainName"
                                  @input="inputForceUpdate"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-form-item label="地址:">
                        <el-input
                            size="mini"
                            type="textarea"
                            :rows="3"
                            case="upper"
                            :title="ebParty.ebPartyRNT.partyAddress"
                            v-model="ebParty.ebPartyRNT.partyAddress" @input="inputForceUpdate">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="国家/地区">
                            <el-associate style="width: 100%;"
                                          :columns="associate_columns_country"
                                          :query-method="associate_queryMethod_country"
                                          class="input_length"
                                          clearable
                                          case="upper"
                                          :query-length="0"
                                          :default-first-option="true"
                                          label-prop="countryNameCn"
                                          value-prop="countryNameCn"
                                          placeholder=""
                                          @change="onChangeCountryEbPartyRNT"
                                          v-model="ebParty.ebPartyRNT.countryName"
                                          :title="ebParty.ebPartyRNT.countryName"
                                          size="mini"
                            />
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item>
                            <label slot="label" class="label_no"></label>
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartyRNT.areaName"
                                v-model="ebParty.ebPartyRNT.areaName" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="邮编/邮箱">
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartyRNT.postCode"
                                v-model="ebParty.ebPartyRNT.postCode" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item>
                            <label slot="label" class="label_no"></label>
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartyRNT.email"
                                v-model="ebParty.ebPartyRNT.email" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="联系人/移动电话">
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartyRNT.contactPerson"
                                v-model="ebParty.ebPartyRNT.contactPerson" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item>
                            <label slot="label" class="label_no"></label>
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartyRNT.mobilePhone"
                                v-model="ebParty.ebPartyRNT.mobilePhone" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-form-item label="海关代码:">
                        <el-input
                            size="mini"
                            case="upper"
                            :title="ebParty.ebPartyRNT.taxNo"
                            v-model="ebParty.ebPartyRNT.taxNo" @input="inputForceUpdate">
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="12">
                          <el-form-item label="AEO代码/船公司代码">
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartyRNT.aeoNo"
                                v-model="ebParty.ebPartyRNT.aeoNo" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item>
                            <label slot="label" class="label_no"></label>
                            <el-input
                                size="mini"
                                case="upper"
                                :title="ebParty.ebPartyRNT.carrierCode"
                                v-model="ebParty.ebPartyRNT.carrierCode" @input="inputForceUpdate">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-form>
                </el-row>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-row style="float:right; padding-bottom:20px">
        <el-col :span="12" class="add-button" style="padding-right:10px">
          <el-button type="primary" size="mini" @click="ebPartyDialogClick"
                     >确 定</el-button> </el-col>
        <el-col :span="12" style="padding-right:10px">
          <el-button type="primary" size="mini" @click="ebPartyDialogVisible = false"
                     >取 消</el-button></el-col>
        </el-row>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { queryCountryInfo, queryMdShipperCneeNotify, queryShipperCneeNotifyShipperInfo } from "@/api/commonService";
import { ebPartySHDialogFormRules, ebPartyFormRules } from "@/rules/booking_rules";
import { saveEbParty } from "@/api/bookingRequest";
import autoFocusMixin from "@/mixin/autoFocus"

export default {
  name: 'ebPartyInfoBill',
  // 接收父组件的值
  props: {
    loadingEditKey: "",
    isHblHlk: "",
    ebParty: {
      //发货人
      ebPartySH: {},
      //收获人
      ebPartyCN: {},
      //通知人
      ebPartyNT: {},
      //通知人
      ebPartyNT2: {},
      //真实发货人
      ebPartyRSH: {},
      //真实收获人
      ebPartyRCN: {},
      //真实通知人
      ebPartyRNT: {},
      //DG
      ebPartyDG: {},
    },
    ebOrder: {},
    ebBlPlan: {}
  },
  mixins: [autoFocusMixin],
  data() {
    return {
      billApprovalStatus: false,
      radio: '0',
      radio1: '0',
      ebPartyInfoFormRules: {},
      //校验
      ebPartyRSHInfoFormRules: {
        ...ebPartyFormRules
      },
      ebPartyRCNInfoFormRules: {
        ...ebPartyFormRules
      },
      ebPartyRNTInfoFormRules: {
        ...ebPartyFormRules
      },
      ebPartySHInfoFormRules: {
        ...ebPartyFormRules
      },
      ebPartyCNInfoFormRules: {
        ...ebPartyFormRules
      },
      ebPartyNTInfoFormRules: {
        ...ebPartyFormRules
      },
      ebPartyNT2InfoFormRules: {
        ...ebPartyFormRules
      },
      ebPartySHDialogFormRules: {
        ...ebPartySHDialogFormRules
      },
      ebPartyCNDialogFormRules: {
        ...ebPartySHDialogFormRules
      },
      ebPartyNTDialogFormRules: {
        ...ebPartySHDialogFormRules
      },
      ebPartyNT2DialogFormRules: {
        ...ebPartySHDialogFormRules
      },
      ebPartyDGDialogFormRules: {
        ...ebPartySHDialogFormRules
      },
      ebPartyRSHDialogFormRules: {
        ...ebPartySHDialogFormRules
      },
      ebPartyRCNDialogFormRules: {
        ...ebPartySHDialogFormRules
      },
      ebPartyRNTDialogFormRules: {
        ...ebPartySHDialogFormRules
      },
      //收发通联想控件
      associate_columns_part: [
        {
          title: "英文名称",
          field: "shipperCneeNotifyNameEn",
        },
        {
          title: "中文名称",
          field: "shipperCneeNotifyNameCn",
        }
      ],
      //国家地区联想控件
      associate_columns_country: [
        {
          title: "国家代码",
          field: 'countryCode'
        },
        {
          title: "中文名称",
          field: 'countryNameCn'
        },
        {
          title: "英文名称",
          field: 'countryNameEn'
        }
      ],
      ebPartyDialogForm: {
        active: '0',
        activeName: '0',
        activeChildName: '0'
      },
      ebPartyDialogFormRules: {},
      ebPartyDialogVisible: false,
    };
  },
  computed: {
    computedEbPartySH() {
      return JSON.stringify(this.ebParty.ebPartySH);
    },
    computedEbPartyCN() {
      return JSON.stringify(this.ebParty.ebPartyCN);
    },
    computedEbPartyNT() {
      return JSON.stringify(this.ebParty.ebPartyNT);
    },
    computedEbPartyNT2() {
      return JSON.stringify(this.ebParty.ebPartyNT2);
    },
    computedEbPartyDG() {
      return JSON.stringify(this.ebParty.ebPartyDG);
    },
    computedEbPartyRSH() {
      return JSON.stringify(this.ebParty.ebPartyRSH);
    },
    computedEbPartyRCN() {
      return JSON.stringify(this.ebParty.ebPartyRCN);
    },
    computedEbPartyRNT() {
      return JSON.stringify(this.ebParty.ebPartyRNT);
    },
    computedEbOrder() {
      return JSON.stringify(this.ebOrder);
    },
  },
  watch: {
    "loadingEditKey": function () {
      this.ebPartyDialogForm.activeName = "0";
    },
    "ebBlPlan.amsSendMode": function () {
      let self = this;
      let amsSendMode = self.ebBlPlan.amsSendMode;
      if(amsSendMode === "FS" || amsSendMode === "CS"){
        let newRules1 = JSON.parse(JSON.stringify(this.ebPartyRSHInfoFormRules));
        let newRules2 = JSON.parse(JSON.stringify(this.ebPartyRNTInfoFormRules));
        let newRules3 = JSON.parse(JSON.stringify(this.ebPartyRCNInfoFormRules));
        newRules1['ebPartyRSH.partyDescription'] = [{required: true, message: '请输入', trigger: 'blur'},]
        newRules2['ebPartyRCN.partyDescription'] = [{required: true, message: '请输入', trigger: 'blur'},]
        newRules3['ebPartyRNT.partyDescription'] = [{required: true, message: '请输入', trigger: 'blur'},]
        this.ebPartyRSHInfoFormRules = newRules1;
        this.ebPartyRNTInfoFormRules = newRules2;
        this.ebPartyRCNInfoFormRules = newRules3;
      }else{
        let newRules1 = JSON.parse(JSON.stringify(this.ebPartyRSHInfoFormRules));
        let newRules2 = JSON.parse(JSON.stringify(this.ebPartyRNTInfoFormRules));
        let newRules3 = JSON.parse(JSON.stringify(this.ebPartyRCNInfoFormRules));
        delete newRules1['ebPartyRSH.partyDescription']
        delete newRules2['ebPartyRCN.partyDescription']
        delete newRules3['ebPartyRNT.partyDescription']
        this.ebPartyRSHInfoFormRules = newRules1;
        this.ebPartyRNTInfoFormRules = newRules2;
        this.ebPartyRCNInfoFormRules = newRules3;
      }
      this.$forceUpdate();
    },
    ebBlPlan() {
      console.log(this.$refs.ebPartyInfoFormRef)
      console.log(this.ebBlPlan)
      if (this.ebBlPlan.approvalStatus === 'SUB' || this.ebBlPlan.approvalStatus === 'CRM') {
        this.billApprovalStatus = true
      } else if (this.ebBlPlan.approvalStatus === 'NEW') {
        this.billApprovalStatus = false;
      }

      if (this.ebOrder.notEditable) {
        if (this.ebOrder.notEditable) {
          this.billApprovalStatus = true;
        } else {
          this.billApprovalStatus = false;
        }
      }
    },
    computedEbPartySH: {
      handler(newValue, oldValue) {
        let newEbPartySH = JSON.parse(newValue);
        if (newEbPartySH.rowStatus === 2) {
          this.ebParty.ebPartySH.rowStatus = 16;
        }
      },
    },
    computedEbPartyCN: {
      handler(newValue, oldValue) {
        let newEbPartyCN = JSON.parse(newValue);
        if (newEbPartyCN.rowStatus === 2) {
          this.ebParty.ebPartyCN.rowStatus = 16;
        }
      },
    },
    computedEbPartyNT: {
      handler(newValue, oldValue) {
        let newEbPartyNT = JSON.parse(newValue);
        if (newEbPartyNT.rowStatus === 2) {
          this.ebParty.ebPartyNT.rowStatus = 16;
        }
      },
    },
    computedEbPartyDG: {
      handler(newValue, oldValue) {
        let newEbPartyDG = JSON.parse(newValue);
        if (newEbPartyDG.rowStatus === 2) {
          this.ebParty.ebPartyDG.rowStatus = 16;
        }
      },
    },
    computedEbPartyNT2: {
      handler(newValue, oldValue) {
        let newEbPartyNT2 = JSON.parse(newValue);
        if (newEbPartyNT2.rowStatus === 2) {
          this.ebParty.ebPartyNT2.rowStatus = 16;
        }
      },
    },
    computedEbPartyRSH: {
      handler(newValue, oldValue) {
        let newEbPartyRSH = JSON.parse(newValue);
        if (newEbPartyRSH.rowStatus === 2) {
          this.ebParty.ebPartyRSH.rowStatus = 16;
        }
      },
    },
    computedEbPartyRCN: {
      handler(newValue, oldValue) {
        let newEbPartyRCN = JSON.parse(newValue);
        if (newEbPartyRCN.rowStatus === 2) {
          this.ebParty.ebPartyRCN.rowStatus = 16;
        }
      },
    },
    computedEbPartyRNT: {
      handler(newValue, oldValue) {
        let newEbPartyRNT = JSON.parse(newValue);
        if (newEbPartyRNT.rowStatus === 2) {
          this.ebParty.ebPartyRNT.rowStatus = 16;
        }
      },
    },
    computedEbOrder: {
      handler(newValue, oldValue) {
        let newEbOrder = JSON.parse(newValue);
        // this.ebOrder = newEbOrder
        this.$emit('update:ebOrder', newEbOrder)
        this.$forceUpdate()
      },
    }
  },
  async created() {

  },
  mounted() {
    console.log(this.ebBlPlan);
  },
  methods: {
    validateAutoFocus() {
      let isAutoFocus = this.autoFocus(this.ebParty, this.ebPartySHInfoFormRules);
    },
    inputForceUpdate() {
      this.$emit('update:ebParty', this.ebParty)
      this.$forceUpdate();
    },
    splitPartyDescription(count){
      let self = this;
      if(self.ebParty.ebPartySH && self.ebParty.ebPartySH.partyDescription){
        self.ebParty.ebPartySH.partyDescription = self.changeStringByCount(count, self.ebParty.ebPartySH.partyDescription);
      };
      if(self.ebParty.ebPartyCN && self.ebParty.ebPartyCN.partyDescription){
        self.ebParty.ebPartyCN.partyDescription = self.changeStringByCount(count, self.ebParty.ebPartyCN.partyDescription);
      };
      if(self.ebParty.ebPartyNT && self.ebParty.ebPartyNT.partyDescription){
        self.ebParty.ebPartyNT.partyDescription = self.changeStringByCount(count, self.ebParty.ebPartyNT.partyDescription);
      };
      if(self.ebParty.ebPartyNT2 && self.ebParty.ebPartyNT2.partyDescription){
        self.ebParty.ebPartyNT2.partyDescription = self.changeStringByCount(count, self.ebParty.ebPartyNT2.partyDescription);
      };
      if(self.ebParty.ebPartyRSH && self.ebParty.ebPartyRSH.partyDescription){
        self.ebParty.ebPartyRSH.partyDescription = self.changeStringByCount(count, self.ebParty.ebPartyRSH.partyDescription);
      };
      if(self.ebParty.ebPartyRCN && self.ebParty.ebPartyRCN.partyDescription){
        self.ebParty.ebPartyRCN.partyDescription = self.changeStringByCount(count, self.ebParty.ebPartyRCN.partyDescription);
      };
      if(self.ebParty.ebPartyRNT && self.ebParty.ebPartyRNT.partyDescription){
        self.ebParty.ebPartyRNT.partyDescription = self.changeStringByCount(count, self.ebParty.ebPartyRNT.partyDescription);
      };
    },
    changeStringByCount(count, str) {
      let self = this;
      str = self.handelSpecialSymbol(str,'before');
      var cargoDescriptionArray = str.split("\n");
      var cargoDescriptionArrayNew = [];
      for (var idx in cargoDescriptionArray) {
        var cargoDescriptionItem = cargoDescriptionArray[idx];
        cargoDescriptionItem = self.strTrim(cargoDescriptionItem);
        var itemInItems = [];
        itemInItems = self.changeStringByCountForItem(count, cargoDescriptionItem, [])
        var cargoDescriptionItem = itemInItems.join("\n");
        cargoDescriptionArrayNew.push(cargoDescriptionItem);
      }
      var returnStr = cargoDescriptionArrayNew.join("\n");
      returnStr = self.handelSpecialSymbol(returnStr,'after');
      return returnStr;
    },
    changeStringByCountForItem(count, strRest, strReturn) {
      let self = this;
      strReturn = strReturn || [];
      strRest = self.strTrim(strRest);
      if (strRest.length > count) {
        for (var n = count; n > 0; n--) {
          if (strRest[n] == ' ') {
            strReturn.push(self.strTrim(strRest.substring(0, n)));
            strRest = strRest.substring(n);
            return self.changeStringByCountForItem(count, strRest, strReturn);
            //break;
          } else if ((strRest[n] == ',') && n != count) {
            strReturn.push(self.strTrim(strRest.substring(0, n + 1)));
            strRest = strRest.substring(n + 1);
            return self.changeStringByCountForItem(count, strRest, strReturn);
          }
        }
        strReturn.push(self.strTrim(strRest.substring(0, count)));
        strRest = strRest.substring(count);
        return self.changeStringByCountForItem(count, strRest, strReturn);
      } else {
        strReturn.push(strRest);
        return strReturn;
      }
    },
    strTrim(str) {
      return str.replace(/(^\s*)|(\s*$)/g, "");
    },
    handelSpecialSymbol(str,type){
      if (type == 'before') {
        str = str.replaceAll("+","++");
        str = str.replaceAll("'","''");
        str = str.replaceAll("?","??");
        str = str.replaceAll(":","::");
      } else {
        str = str.replaceAll("++","+");
        str = str.replaceAll("''","'");
        str = str.replaceAll("??","?");
        str = str.replaceAll("::",":");
      }
      return str;
    },
    // 收发通发货人联想控件数据源
    associate_queryMethod_party_SH({ keyword, pageSize, currentPage }) {
      let params = {
        currentPage: currentPage,
        pageSize: pageSize,
        shipperCneeNotifyName: keyword,
        isShipper: 1
      };
      return new Promise(resolve => {
        queryMdShipperCneeNotify(params).then(res => {
          console.log("queryShipperCneeNotifyShipperInfo", res)
          resolve({
            records: res.records.records,
            total: res.records.totalRecord
          })
        })
      }).catch(err => {
        console.log(err)
      })
    },
    // 收发通收货人联想控件数据源
    associate_queryMethod_party_CN({ keyword, pageSize, currentPage }) {
      let params = {
        currentPage: currentPage,
        pageSize: pageSize,
        shipperCneeNotifyName: keyword,
        isConsignee: 1
      };
      return new Promise(resolve => {
        queryMdShipperCneeNotify(params).then(res => {
          console.log("queryShipperCneeNotifyShipperInfo", res)
          resolve({
            records: res.records.records,
            total: res.records.totalRecord
          })
        })
      }).catch(err => {
        console.log(err)
      })
    },
    // 收发通通知人联想控件数据源
    associate_queryMethod_party_NT({ keyword, pageSize, currentPage }) {
      let params = {
        currentPage: currentPage,
        pageSize: pageSize,
        shipperCneeNotifyName: keyword,
        isNotify: 1
      };
      return new Promise(resolve => {
        queryMdShipperCneeNotify(params).then(res => {
          console.log("queryShipperCneeNotifyShipperInfo", res)
          resolve({
            records: res.records.records,
            total: res.records.totalRecord
          })
        })
      }).catch(err => {
        console.log(err)
      })
    },
    // 收发通通知人联想控件数据源
    associate_queryMethod_party_NT2({ keyword, pageSize, currentPage }) {
      let params = {
        currentPage: currentPage,
        pageSize: pageSize,
        shipperCneeNotifyName: keyword,
        isNotify: 1
      };
      return new Promise(resolve => {
        queryMdShipperCneeNotify(params).then(res => {
          console.log("queryShipperCneeNotifyShipperInfo", res)
          resolve({
            records: res.records.records,
            total: res.records.totalRecord
          })
        })
      }).catch(err => {
        console.log(err)
      })
    },
    // 国家地区联想控件数据源
    associate_queryMethod_country({ keyword, pageSize, currentPage }) {
      let params = {}
      if (keyword === '') {
        params = {
          isDeleted3: "0",
          isActive4: "1"
        }
      } else {
        params = {
          countryCode0: "%" + keyword + "%",
          countryNameCn1: "%" + keyword + "%",
          countryNameEn2: "%" + keyword + "%",
          isDeleted3: "0",
          isActive4: "1"
        }
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdCountry.countryCode"],
        mainModelName: "CTS_ILPMdCountry",
        tag: "CTS_ILP_es",
        where: "((((CTS_ILPMdCountry.countryCode LIKE :countryCode0 OR CTS_ILPMdCountry.countryNameCn LIKE :countryNameCn1) OR CTS_ILPMdCountry.countryNameEn LIKE :countryNameEn2) AND CTS_ILPMdCountry.isDeleted = :isDeleted3) AND CTS_ILPMdCountry.isActive = :isActive4)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: ["CTS_ILPMdCountry.mdCountryId", "CTS_ILPMdCountry.isDeleted", "CTS_ILPMdCountry.lastModifyTime", "CTS_ILPMdCountry.lastModifierName", "CTS_ILPMdCountry.countryNameCn", "CTS_ILPMdCountry.appCode", "CTS_ILPMdCountry.continentsCode", "CTS_ILPMdCountry.createOfficeName", "CTS_ILPMdCountry.createOffice", "CTS_ILPMdCountry.creatorId", "CTS_ILPMdCountry.countryCode", "CTS_ILPMdCountry.countryNameEn", "CTS_ILPMdCountry.isActive", "CTS_ILPMdCountry.lastModifyOffice", "CTS_ILPMdCountry.createTime", "CTS_ILPMdCountry.principalGroupCode", "CTS_ILPMdCountry.recordVersion", "CTS_ILPMdCountry.lastModifyOfficeName", "CTS_ILPMdCountry.creatorName", "CTS_ILPMdCountry.lastModifierId"],
        enableCascade: true
      }

      return new Promise(resolve => {
        queryCountryInfo(data).then(res => {
          console.log("queryCountryInfo", res)
          resolve({
            records: res.data.data,
            total: res.data.totalRecord
          })
        })
      }).catch(err => {
        console.log(err)
      })
    },
    handleClick(el) {},
    //触发表单校验
    ebPartyValidate(callback) {
      let self = this
      let flag = false;
      self.$refs.ebPartySHInfoFormRef.validate(validSH => {
        self.$refs.ebPartyCNInfoFormRef.validate(validCN => {
          self.$refs.ebPartyNTInfoFormRef.validate(validNT => {
            //this.$emit('ebPartyValidate',validSH && validCN && validNT)
            flag = validSH && validCN && validNT
            // return validSH && validCN && validNT
            if(callback) callback(flag)
          })
        })
      })
    },
    //触发弹出框校验
    ebPartyDialogValidate() {
      let self = this
      let flag = false;
      self.$refs.ebPartySHDialogFormRef.validate(async validSH1 => {
        self.$refs.ebPartyCNDialogFormRef.validate(async validCN1 => {
          self.$refs.ebPartyNTDialogFormRef.validate(async validNT1 => {
            self.$refs.ebPartyNT2DialogFormRef.validate(async validNT2 => {
              self.$refs.ebPartyRSHDialogFormRef.validate(async validRSH => {
                self.$refs.ebPartyRCNDialogFormRef.validate(async validRCN => {
                  self.$refs.ebPartyRNTDialogFormRef.validate(async validRNT => {
                    flag = validSH1 && validCN1 && validNT1 && validNT2 && validRSH && validRCN && validRNT
                  })
                })
              })
            })
          })
        })
      })
      if (flag) {
        return true
      }
    },
    copyCnee(val) {
      let self = this
      if (val === "1") {
        self.ebParty.ebPartyNT.partyDescription = self.ebParty.ebPartyCN.partyDescription
      } else if (val === "2") {
        self.ebParty.ebPartyNT.partyDescription = 'SAME AS CONSIGNEE'
      }
      self.ebPartyInfoValue()
    },
    copyRCnee(val) {
      let self = this
      if (val === "1") {
        self.ebParty.ebPartyRNT.partyDescription = self.ebParty.ebPartyRCN.partyDescription
      } else if (val === "2") {
        self.ebParty.ebPartyRNT.partyDescription = 'SAME AS CONSIGNEE'
      }
      self.ebPartyInfoValue();
      this.$forceUpdate();
    },
    ebPartyDialogClick() {
      if (this.ebPartyDialogValidate()) {
        this.$emit('getEbPartyInfo', this.ebParty)
        this.ebPartyDialogVisible = !this.ebPartyDialogVisible
      }
    },
    ebPartyInfoValue() {
      this.$emit('getEbPartyInfo', this.ebParty);
    },
    saveEbPartys(saveData, name) {
      let self = this;
      saveEbParty(saveData).then((res) => {
        if (res.success) {
          self.$coreMethods.message("success", name + "保存成功");
        }
      });
    },
    //把文本框中的内容保存到收发通表中
    saveShipperCneeNotifyRSH() {
      let self = this;
      self.$refs.ebPartyRSHInfoFormRef.validate(validRSH => {
        if (validRSH) {
          let saveData = {
            scnDescription: self.ebParty.ebPartyRSH.partyDescription,
            shipperCneeNotifyNameEn: self.ebParty.ebPartyRSH.partyMainName,
            isNotify: 0,
            isConsignee: 0,
            isShipper: 1
          }
          self.saveEbPartys(saveData, "发货人");
        } else {
          self.$coreMethods.message("warning", "发货人的制单信息不能为空");
        }
      })
    },
    //把文本框中的内容保存到收发通表中
    saveShipperCneeNotifyRCN() {
      let self = this;
      self.$refs.ebPartyRCNInfoFormRef.validate(validRCN => {
        if (validRCN) {
          let saveData = {
            scnDescription: self.ebParty.ebPartyRCN.partyDescription,
            shipperCneeNotifyNameEn: self.ebParty.ebPartyRCN.partyMainName,
            isNotify: 0,
            isConsignee: 1,
            isShipper: 0
          }
          self.saveEbPartys(saveData, "收货人");
        } else {
          self.$coreMethods.message("warning", "收货人的制单信息不能为空");
        }
      })
    },
    //把文本框中的内容保存到收发通表中
    saveShipperCneeNotifyRNT() {
      let self = this;
      self.$refs.ebPartyRNTInfoFormRef.validate(validRNT => {
        if (validRNT) {
          let saveData = {
            scnDescription: self.ebParty.ebPartyRNT.partyDescription,
            shipperCneeNotifyNameEn: self.ebPartyRNT.ebPartyCN.partyMainName,
            isNotify: 1,
            isConsignee: 0,
            isShipper: 0
          }
          self.saveEbPartys(saveData, "通知人");
        } else {
          self.$coreMethods.message("warning", "通知人的制单信息不能为空");
        }
      })
    },
    //把文本框中的内容保存到收发通表中
    saveShipperCneeNotifySH() {
      let self = this;
      self.$refs.ebPartySHInfoFormRef.validate(validSH => {
        if (validSH) {
          let saveData = {
            scnDescription: self.ebParty.ebPartySH.partyDescription,
            shipperCneeNotifyNameEn: self.ebParty.ebPartySH.partyMainName,
            isNotify: 0,
            isConsignee: 0,
            isShipper: 1
          }
          if (saveData.scnDescription === undefined ||
            saveData.scnDescription === "" ||
            saveData.scnDescription === null) {
            self.$coreMethods.message("warning", "制单信息不能为空");
            return;
          }
          if (saveData.shipperCneeNotifyNameEn === undefined ||
            saveData.shipperCneeNotifyNameEn === "" ||
            saveData.shipperCneeNotifyNameEn === null) {
            self.$coreMethods.message("warning", "发货人名称不能为空");
            return;
          }
          self.saveEbPartys(saveData, "发货人");
        } else {
          self.$coreMethods.message("warning", "发货人名称和制单信息不能为空");
        }
      })
    },
    //把文本框中的内容保存到收发通表中
    saveShipperCneeNotifyCN() {
      let self = this;
      self.$refs.ebPartyCNInfoFormRef.validate(validCN => {
        if (validCN) {
          let saveData = {
            scnDescription: self.ebParty.ebPartyCN.partyDescription,
            shipperCneeNotifyNameEn: self.ebParty.ebPartyCN.partyMainName,
            isNotify: 0,
            isConsignee: 1,
            isShipper: 0
          }
          if (saveData.scnDescription === undefined ||
            saveData.scnDescription === "" ||
            saveData.scnDescription === null) {
            self.$coreMethods.message("warning", "制单信息不能为空");
            return;
          }
          if (saveData.shipperCneeNotifyNameEn === undefined ||
            saveData.shipperCneeNotifyNameEn === "" ||
            saveData.shipperCneeNotifyNameEn === null) {
            self.$coreMethods.message("warning", "收货人名称不能为空");
            return;
          }
          self.saveEbPartys(saveData, "收货人");
        } else {
          self.$coreMethods.message("warning", "收货人名称和制单信息不能为空");
        }
      })
    },
    //把文本框中的内容保存到收发通表中
    saveShipperCneeNotifyNT() {
      let self = this;
      self.$refs.ebPartyNTInfoFormRef.validate(validNT => {
        if (validNT) {
          let saveData = {
            scnDescription: self.ebParty.ebPartyNT.partyDescription,
            shipperCneeNotifyNameEn: self.ebParty.ebPartyNT.partyMainName,
            isNotify: 1,
            isConsignee: 0,
            isShipper: 0
          }
          if (saveData.scnDescription === undefined ||
            saveData.scnDescription === "" ||
            saveData.scnDescription === null) {
            self.$coreMethods.message("warning", "制单信息不能为空");
            return;
          }
          if (saveData.shipperCneeNotifyNameEn === undefined ||
            saveData.shipperCneeNotifyNameEn === "" ||
            saveData.shipperCneeNotifyNameEn === null) {
            self.$coreMethods.message("warning", "通知人名称不能为空");
            return;
          }
          self.saveEbPartys(saveData, "通知人");
        } else {
          self.$coreMethods.message("warning", "通知人名称和制单信息不能为空");
        }
      })
    },
    saveShipperCneeNotifyNT2() {
      let self = this;
      self.$refs.ebPartyNT2InfoFormRef.validate(validNT2 => {
        if (validNT2) {
          let saveData = {
            scnDescription: self.ebParty.ebPartyNT2.partyDescription,
            shipperCneeNotifyNameEn: self.ebParty.ebPartyNT2.partyMainName,
            isNotify: 1,
            isConsignee: 0,
            isShipper: 0
          }
          if (saveData.scnDescription === undefined ||
            saveData.scnDescription === "" ||
            saveData.scnDescription === null) {
            self.$coreMethods.message("warning", "制单信息不能为空");
            return;
          }
          if (saveData.shipperCneeNotifyNameEn === undefined ||
            saveData.shipperCneeNotifyNameEn === "" ||
            saveData.shipperCneeNotifyNameEn === null) {
            self.$coreMethods.message("warning", "通知人名称不能为空");
            return;
          }
          self.saveEbPartys(saveData, "通知人");
        } else {
          self.$coreMethods.message("warning", "通知人名称和制单信息不能为空");
        }
      })
    },
    //真实收发通发货人联想控件改变事件
    onChangePartRSH(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      if (selectedRows.scnDescription !== null) {
        this.ebParty.ebPartyRSH.partyDescription = selectedRows.scnDescription;
      }
      this.ebParty.ebPartySH.mdShipperCneeNotifyId = selectedRows.mdShipperCneeNotifyId;
      this.$refs.ebPartyRSHInfoFormRef.validate();
      this.$emit('getEbPartyInfo', this.ebParty);
      this.$forceUpdate();

    },
    //真实收发通发货人联想控件改变事件
    onChangePartRCN(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      if (selectedRows.scnDescription !== null) {
        this.ebParty.ebPartyRCN.partyDescription = selectedRows.scnDescription;
      }
      this.ebParty.ebPartyRCN.mdShipperCneeNotifyId = selectedRows.mdShipperCneeNotifyId;
      this.$refs.ebPartyRCNInfoFormRef.validate();
      this.$emit('getEbPartyInfo', this.ebParty);
      this.$forceUpdate();
    },
    //收发通发货人联想控件改变事件
    onChangePartRNT(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      if (selectedRows.scnDescription !== null) {
        this.ebParty.ebPartyRNT.partyDescription = selectedRows.scnDescription;
      }
      this.ebParty.ebPartyRNT.mdShipperCneeNotifyId = selectedRows.mdShipperCneeNotifyId;
      this.$refs.ebPartyRCNInfoFormRef.validate();
      this.$emit('getEbPartyInfo', this.ebParty);
      this.$forceUpdate();
    },
    //收发通发货人联想控件改变事件
    onChangePartSH(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      if (selectedRows.scnDescription !== null) {
        this.ebParty.ebPartySH.partyDescription = selectedRows.scnDescription;
      }
      this.ebParty.ebPartySH.mdShipperCneeNotifyId = selectedRows.mdShipperCneeNotifyId;
      this.$refs.ebPartySHInfoFormRef.validate();
      this.$emit('getEbPartyInfo', this.ebParty);
      this.$forceUpdate();
    },
    //收发通发货人联想控件改变事件
    onChangePartCN(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      if (selectedRows.scnDescription !== null) {
        this.ebParty.ebPartyCN.partyDescription = selectedRows.scnDescription;
      }
      this.ebParty.ebPartyCN.mdShipperCneeNotifyId = selectedRows.mdShipperCneeNotifyId;
      this.$refs.ebPartyCNInfoFormRef.validate();
      this.$emit('getEbPartyInfo', this.ebParty);
      this.$forceUpdate();
    },
    //收发通发货人联想控件改变事件
    onChangePartNT(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      if (selectedRows.scnDescription !== null) {
        this.ebParty.ebPartyNT.partyDescription = selectedRows.scnDescription;
      }
      this.ebParty.ebPartyNT.mdShipperCneeNotifyId = selectedRows.mdShipperCneeNotifyId;
      this.$refs.ebPartyNTInfoFormRef.validate();
      this.$emit('getEbPartyInfo', this.ebParty);
      this.$forceUpdate();
    },
    //收发通发货人联想控件改变事件
    onChangePartNT2(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      if (selectedRows.scnDescription !== null && selectedRows.scnDescription !== undefined) {
        this.ebParty.ebPartyNT2.partyDescription = selectedRows.scnDescription;
      }
      this.ebParty.ebPartyNT2.mdShipperCneeNotifyId = selectedRows.mdShipperCneeNotifyId;
      this.$refs.ebPartyNT2InfoFormRef.validate();
      this.$emit('getEbPartyInfo', this.ebParty);
      this.$forceUpdate();
    },
    // 国家/地区
    onChangeCountryEbPartySH(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebParty.ebPartySH.countryCode = selectedRows.countryCode;
      this.$forceUpdate();
    },
    onChangeCountryEbPartyCN(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebParty.ebPartyCN.countryCode = selectedRows.countryCode;
      this.$forceUpdate();
    },
    onChangeCountryEbPartyNT(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebParty.ebPartyNT.countryCode = selectedRows.countryCode;
      this.$forceUpdate();
    },
    onChangeCountryEbPartyNT2(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebParty.ebPartyNT2.countryCode = selectedRows.countryCode;
      this.$forceUpdate();
    },
    onChangeCountryEbPartyRSH(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebParty.ebPartyRSH.countryCode = selectedRows.countryCode;
      this.$forceUpdate();
    },
    onChangeCountryEbPartyRCN(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebParty.ebPartyRCN.countryCode = selectedRows.countryCode;
      this.$forceUpdate();
    },
    onChangeCountryEbPartyRNT(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebParty.ebPartyRNT.countryCode = selectedRows.countryCode;
      this.$forceUpdate();
    },
    onChangeCountryEbPartyDG(value, selectedRows) {
      console.log("selectedRows", selectedRows);
      this.ebParty.ebPartyDG.countryCode = selectedRows.countryCode;
      this.$forceUpdate();
    },
  }
};
</script>

<style scoped lang="scss">
.redItem.el-form-item__label {
  color: red;
}
</style>
